import { Navigate } from 'react-router-dom';
import { useAuth } from './AuthContext';
import { LoginPage } from './LoginPage';
import { RoleHomeRedirect, homePathForUser, AccessUnavailable, LOGIN_PATH } from './RoleHomeRedirect';

/**
 * `/`: only the login for an anonymous visitor; an existing session is sent
 * to its safe destination without flashing the form (spec: "Una sesión ya
 * válida redirige sin mostrar brevemente el login"). Because the switch is
 * driven by `status`, a successful login re-renders this route into the
 * redirect on its own, instead of leaving the form stuck on its submit state.
 */
export function EntryRoute() {
  const { status } = useAuth();
  if (status === 'authenticated') return <RoleHomeRedirect />;
  return <LoginPage />;
}

/**
 * `/cambiar-password` is available to mandatory changes and voluntary
 * changes by admin/coach; everyone else goes to the login or their own home.
 */
export function PasswordChangeRoute({ children }) {
  const { user } = useAuth();
  if (!user) return <Navigate to={LOGIN_PATH} replace />;
  if (user.mustChangePassword || user.role === 'admin' || user.role === 'coach') return children;
  const home = homePathForUser(user);
  if (!home) return <AccessUnavailable />;
  return <Navigate to={home} replace />;
}
